import { send } from '../../../../../../src/network/network';
import { type PaginatedCustomerTagListList } from '../../../../../../src/types/PaginatedCustomerTagListList';

export type { PaginatedCustomerTagListList };

type Params = {
  limit?: number;
  offset?: number;
  customerId: number | 'self';
  tagIn?: number[];
};

export async function getApiV2CustomersCustomerIdTags(params: Params) {
  const queryParams = new URLSearchParams();

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  if (params.tagIn !== undefined) {
    queryParams.append(
      'tag__in',
      params.tagIn.map((tag) => tag.toString()).join(',')
    );
  }

  return await send<PaginatedCustomerTagListList>({
    path: `/api/v2/customers/${params.customerId}/tags/`,
    method: 'GET',
    query: queryParams,
  });
}
